import React from "react";
import moment from "moment";

const Badge = ({ value }) => {
    return value ? (
        <span className="badge bg-label-success me-1">
            <i className="menu-icon tf-icons bx bx-check" />
        </span>
    ) : (
        <span className="badge bg-label-danger me-1">
            <i className="menu-icon tf-icons bx bx-x" />
        </span>
    );
};

const TabelaPagamentosVideos = ({ data = [] }) => {
    const listaOrdenada = [...data].sort((a, b) =>
        moment(b.dataPagamento).diff(moment(a.dataPagamento))
    );

    return (
        <table className="table">
            <thead>
                <tr>
                    <th>Ordem</th>
                    <th>Vip</th>
                    <th>Atleta</th>
                    <th>CPF</th>
                    <th>Email</th>
                    <th>Evento</th>
                    <th>Vídeo</th>
                    <th>Valor</th>
                    <th>Data Pagamento</th>
                </tr>
            </thead>

            <tbody className="table-border-bottom-0">
                {listaOrdenada.length > 0 ? (
                    listaOrdenada.map((pagamento, index) => (
                        <tr key={index}>
                            <td>{index + 1}</td>
                            <td>
                                <Badge value={pagamento.salaVip} />
                            </td>

                            <td>{pagamento.nomeUsuario}</td>
                            <td>{pagamento.cpf}</td>
                            <td>{pagamento.email}</td>
                            <td>{pagamento.nomeEvento}</td>
                            <td>{pagamento.nomeVideo}</td>

                            <td>
                                {pagamento.valor.toLocaleString("pt-BR", {
                                    style: "currency",
                                    currency: "BRL",
                                })}
                            </td>

                            <td>
                                {pagamento.dataPagamento
                                    ? moment(pagamento.dataPagamento).format(
                                        "DD/MM/YYYY - HH:mm"
                                    )
                                    : "-"}
                            </td>
                        </tr>
                    ))
                ) : (
                    <tr>
                        <td colSpan="8" style={{ textAlign: "center", padding: 10 }}>
                            Sem eventos pagamentos
                        </td>
                    </tr>
                )}
            </tbody>
        </table>
    );
};

export default TabelaPagamentosVideos;